import { addModal } from 'modules/messageSystem/actions/addModal';
import {
  UPLOAD_AVATAR_INCORRECT_EXTENSION_MODAL,
  UPLOAD_AVATAR_SIZE_EXCEEDED,
  UPLOAD_AVATAR_FAILURE_MODAL,
} from 'modules/messageSystem/constants/modalCodes';

export const invokeIncorrectExtensionModal = fileType => addModal({
  typeId: UPLOAD_AVATAR_INCORRECT_EXTENSION_MODAL,
  preventClosingWhenDismiss: true,
  canAddDuplicate: false,
  isForce: true,
  bodyValues: { fileType },
});

export const invokeFileSizeExceededModal = (fileType, maxSizeMB) => addModal({
  typeId: UPLOAD_AVATAR_SIZE_EXCEEDED,
  preventClosingWhenDismiss: true,
  canAddDuplicate: false,
  isForce: true,
  bodyValues: { fileType, maxSizeMB },
});

export const invokeUploadAvatarFailureModal = () => addModal({
  typeId: UPLOAD_AVATAR_FAILURE_MODAL,
  canAddDuplicate: false,
});
